import { useContext, useState } from 'react';
import { Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { RuntimeContext } from '../../../../common/RuntimeContext';
import VerbButton, { VERB_BUTTON_TYPE } from '../../../shared/components/VerbButton';
import VerbHeading from '../../../shared/components/VerbHeading';
import TeamCard from '../../components/widgets/TeamCard';

const GroupList = () => {
    const config = useContext(RuntimeContext)
    const loggedInUser = useSelector(({ auth }) => auth?.loggedInUser);
    const loggedInUserId = useSelector(({ auth }) => auth?.loggedInUserId);
    const profiles = useSelector(({ profiles }) => profiles);
    const teams = useSelector(({ teams }) => teams?.byId);

    const activeUserTeams = [];
    const userTeams = profiles.byId[loggedInUserId].teams;

    (userTeams || []).forEach((team) => {
        if (teams && teams[team.teamId] && teams[team.teamId].isActive) {
            activeUserTeams.push({ ...teams[team.teamId], joinedDateTime: team.joinedDateTime });
        }
    })

    const [loadAll, setLoadAll] = useState(false);
    const [maxDisplayValue, setMaxDisplayValue] = useState(8);

    const setLoadAllButton = () => {
        setLoadAll(true);
        setMaxDisplayValue(activeUserTeams.length);
    };

    return (
        <div className={'group-list-page'}>
            <div className={'container'}>
                <div className={'heading-container'}>
                    <VerbHeading
                        className={'col-12 home-row-wrapper-heading'}
                        messageId={'TEAMS'}
                        hNumber={5}
                        defaultMessage={'Teams'}
                    />
                </div>
                <Row>
                    {activeUserTeams.slice(0, maxDisplayValue).map((team, index) => (
                        <div key={team._id} className={'col-sm-12 col-md-6 team-card-group'}>
                            <TeamCard team={team} index={index} />
                        </div>
                    ))}
                </Row>
            </div>
            {!loadAll && activeUserTeams.length > maxDisplayValue && (
                <div className={'load-all-container col-12'}>
                    <div>
                        <VerbButton
                            className={'load-all-button'}
                            buttonType={VERB_BUTTON_TYPE.SECONDARY_DEFAULT}
                            defaultMessage={'LOAD ALL'}
                            buttonText={'LOAD ALL'}
                            onClick={setLoadAllButton}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default GroupList;
